import {
  Paper,
  Tabs,
  Tab,
  Grid,
  Button,
  Box,
  Typography,
  Stack,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { ReactComponent as CopyFromDoctorIcon } from "../../../../../assets/icons/MedintCopyFromDoctorIcon.svg";
import { ReactComponent as MultipleAddIcon } from "../../../../../assets/icons/MedintMultipleAddIcon.svg";
import { ReactComponent as AddIcon } from "../../../../../assets/icons/MedintAddIcon.svg";
import { ReactComponent as ModifyIcon } from "../../../../../assets/icons/MedintModifyIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/icons/MedintDeleteIcon.svg";
import "../../../../../css/medint.css";
import { useContext, useEffect, useState } from "react";
import MedintTable from "../../MedintTable/MedintTable";
import MedintBookingAgenda from "../Bookings/Agenda/MedintBookingAgenda";
import MedintModal from "../../MedintModal/MedintModal";
import NotAvailableTab from "./NotAvailable/NotAvailable";
import MedintFormInterface, {
  AgendaDettaglio,
  medintModalTypes,
  Prestazione,
  PrestazioneAbbinata,
} from "../../../../../services/medintInterfaces";
import { MedintDataContext } from "../../../Context/MedintContextWrapper";
import dayjs from "dayjs";
import MedPrest from "./MedPrestModal/MedPrest";
import {
  RHFAutocomplete,
  RHFCheckbox,
  RHFTextField,
} from "../../../../RHFComponents/RHFComponents";
import { UseFormReturn } from "react-hook-form";
import { StyledDataGrid } from "../../../../AppointmentManagement/AppointmentManagementDetail/AppointmentManagementDetail";
import { GridColDef } from "@mui/x-data-grid";
import { medpgm } from "../../../../../networking";
import { AllertMessage } from "../MedintDetails";
import { useLocation, useNavigate } from "react-router-dom";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const MedintBookings = (props: {
  fetchDataMedico: () => Promise<void>;
  methods: UseFormReturn<MedintFormInterface>;
  setHideDetailsActions?: (hide: boolean) => void;
  allertMessageProps: {
    showAllert: boolean;
    setShowAllert: React.Dispatch<React.SetStateAction<boolean>>;
    setMessage: React.Dispatch<React.SetStateAction<string>>;
    setSeverity: React.Dispatch<React.SetStateAction<string>>;
    severity: string;
    message: string;
    dataToSend: any;
    submitFunction: (() => void) | null;
    setFn: React.Dispatch<React.SetStateAction<(() => void) | null>>;
  };
}) => {
  const context = useContext(MedintDataContext);

  const [selectedAgenda, setSelectedAgenda] = useState<any>();

  const [selectedErogate, setSelectedErogate] = useState<any>(null);

  const [selectedAbbinate, setSelectedAbbinate] = useState<any>(null);

  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loading, setLoading] = useState<boolean>(false);

  type MedPrestOpenState =
    | { open: false }
    | { open: true; mode: "create" | "edit" | "copy"; row?: any };

  const [medPrest, setMedPrest] = useState<MedPrestOpenState>({ open: false });

  const [dataGeneral, setDataGeneral] = useState<{ [key: string]: any }[]>([]);

  const [dataPrestazioniErogabiliAgenda, setDataPrestazioniErogabili] =
    useState<{ [key: string]: any }[]>([]);

  const [dataPrestazioniAbbinate, setPrestazioniAbbinate] = useState<
    { [key: string]: any }[]
  >([]);

  // States gestione allert
  const [showAllert, setShowAllert] = useState<boolean>(false);
  const [severity, setSeverity] = useState<string>("error");
  const [message, setMessage] = useState<string>("Testo di default");
  const [dataToSend, setDataToSend] = useState<any>(null);

  const [modalType, setModalType] = useState<medintModalTypes>(null);

  //Stato per gestire la fase di visualizzazione delle tabelle in MedintBookingAgenda
  const [insertPhase, setInsertPhase] = useState<0 | 1 | 2>(0);

  //Servono per quando si torna indietro da MedintAgendaFormDetail,
  // in modo da mostrare il componente, altrimenti mostrerebbe MedintDetails vuoto
  const location = useLocation();
  const navigate = useNavigate();

  //Cambia lo stato selectedTab da 0 a 1 in base alla Tab selezionata dall'utente
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
    setInsertPhase(0);
  };

  useEffect(() => {
    console.log("AGENDE", props.methods.getValues("agendeAttive"));
    dataGeneral.forEach((e) => {
      console.log("datafin ", e.dataFin);
      // dataFin format è YYYY-MM-DD
      if (e.dataFin < dayjs()) {
        console.log("SCADUTO");
      }
    });
    console.log("dayjs ", dayjs().format("YYYY-MM-DD"));
  }, [props.methods.watch("agendeAttive")]);

  // UseEffect che si attiva al caricamento del componente e controlla se è necessario
  // riaprire la modale di dettaglio dell'agenda
  useEffect(() => {
    const st = (location.state as any) ?? {};
    const reopen = st.reopenModal ?? st.reopenModalType;
    if (reopen) {
      setModalType(reopen);
      setIsModalOpen(true);
      const next = { ...st };
      delete next.reopenModal;
      delete next.reopenModalType;
      navigate(location.pathname, { replace: true, state: next });
    }
  }, []);

  const headers = ["Specialità", "Codice", "Descrizione", "Agenda", "Durata"];

  // INIZIALIZZAZIONE DATI TABELLA DI *PRESTAZIONI EROGABILI*
  useEffect(() => {
    console.log("prestazioni erogabili", context?.doctorAgenda?.prestazioni);
    const dataDettagliPrestazioni = context?.doctorAgenda?.prestazioni.map(
      (e: Prestazione) => {
        return {
          Specialità: e.CODICESPECIALITA,
          Codice: e.CODICEANAPRE,
          Descrizione: e.DSCANAPRE,
          Agenda: e.DESCRTIPOAGENDA,
          IdMedPrest: e.IDMEDPREST,
          Durata: e.DURATAPREST + " min",
          AttesaPrest: e.ATTESAPREST,
          NMaxPrest: e.NMAXPREST,
        };
      },
    );
    console.log("oggetto mappato", dataDettagliPrestazioni);
    context?.setPrestazioniErogabili(dataDettagliPrestazioni);
  }, [context?.doctorAgenda]);

  // INIZIALIZZAZIONE DAT TABELLA *AGENDE* CON RELATIVE PRESTAZIONI EROGATE / ABBINATE
  useEffect(() => {
    const data =
      context?.doctorAgenda?.agende?.agenda !== undefined
        ? context?.doctorAgenda?.agende?.agenda.map(
            (e: AgendaDettaglio, index: number) => {
              const dataPrestazioniAbbinateTemp = e.prestazioniabbinate
                ? e.prestazioniabbinate.map(
                    (j: PrestazioneAbbinata, index: number) => {
                      return {
                        id: index,
                        idMedpgmp: j.IDMEDPGMP,
                        idMedpgm: j.IDMEDPGM,
                        idAnapre: j.IDANAPRE,
                        specialita: j.CODICESPECIALITA,
                        prestazione: j.CODICEPRESTAZIONE,
                        descrizione: j.DESCRPRESTAZIONE,
                        tipologia: j.DESCRTIPOAGENDA,
                        codiceTipoAgenda: j.CODICETIPOAGENDA,
                        programmaAbbinato: e.DSCPGMEDT
                      };
                    },
                  )
                : [];

              const dataPrestazioniErogabiliAgenda =
                context?.doctorAgenda.prestazioni.map(
                  (e: Prestazione, index: number) => {
                    return {
                      id: index,
                      idAnapre: e.IDANAPRE,
                      idMedPrest: e.IDMEDPREST,
                      codTpgpre: e.CODICETPGPRE,
                      nMaxPrest: e.NMAXPREST,
                      durataPrest: e.DURATAPREST,
                      attestaPrest: e.ATTESAPREST,
                      specialita: e.CODICESPECIALITA,
                      prestazione: e.CODICEANAPRE,
                      descrizione: e.DSCANAPRE,
                      tipologia: e.DESCRTIPOAGENDA,
                    };
                  },
                );

              setDataPrestazioniErogabili(dataPrestazioniErogabiliAgenda);

              return {
                id: index,
                idMedpgm: e.IDMEDPGM,
                idPgMedt: e.IDPGMEDT,
                dataIni: e.DATAINIVAL,
                dataFin: e.DATAFINEVAL,
                codAgenda: e.CODICEPGMEDT,
                programmaAbb: e.DSCPGMEDT,
                prestazioniAbbinate: dataPrestazioniAbbinateTemp,
              };
            },
          )
        : [];

    setDataGeneral(data);
  }, [
    context?.doctorAgenda?.agende?.agenda,
    context?.doctorAgenda?.prestazioni,
  ]);

  // reset delle selezioni al caricamento o al cambio della selezione della agenda
  useEffect(() => {
    context?.setPrestazioniAbbinate([]);
  }, [selectedTab]);

  useEffect(() => {
    setSelectedErogate([]);
    setSelectedAbbinate([]);
  }, [selectedAgenda, selectedTab]);

  const handleCloseModal = async () => {
    setIsModalOpen(false);
    await props.fetchDataMedico();
  };

  const handleSubmitModal = () => {
    console.log("Salvato!");
    setIsModalOpen(false);
  };

  const openModal = (type: medintModalTypes) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  /*Funzione che gestisce il click sul bottone "Inserisci" nella sezione Agenda*/
  const handleInsertAgenda = () => {
    setModalType("nuovaAgenda");
    setIsModalOpen(true);
  };

  const handleEditAgenda = (data: any) => {
    const result = {
      codProg: data.codAgenda,
      descrizione: data.programmaAbb,
    };

    props.methods.setValue("testataAgenda.codProgramma", result);

    setIsModalOpen(true);
    setModalType("nuovaAgenda");

    props.methods.setValue("testataAgenda.state", "update");
    props.methods.setValue("testataAgenda.dataIni", dayjs(data.dataIni));
    props.methods.setValue("testataAgenda.dataFin", dayjs(data.dataFin));
    props.methods.setValue("testataAgenda.idMedPgm", data.idMedpgm);
    props.methods.setValue("testataAgenda.idMedT", data.idPgMedt);
  };

  const handleDuplicateAgenda = async (data: any) => {
    setModalType("nuovaAgenda");
    props.methods.setValue("testataAgenda.state", "copy");
    props.methods.setValue("testataAgenda.dataIni", dayjs(data.dataIni));
    props.methods.setValue("testataAgenda.dataFin", dayjs(data.dataFin));
    props.methods.setValue("testataAgenda.idMedPgm", data.idMedpgm);
    props.methods.setValue("testataAgenda.idMedT", data.idPgMedt);
    const result = {
      codProg: data.codAgenda,
      descrizione: data.programmaAbb,
    };
    props.methods.setValue("testataAgenda.codProgramma", result);
    setIsModalOpen(true);
  };

  const onClickCancellazioneAgenda = async (data: any) => {
    props.allertMessageProps.setFn(() => () => handleDeleteAgenda(data));
    setMessage(
      "Procedere con la cancellazione fisica / definitiva di questa agenda?",
    );
    setSeverity("warning");
    setShowAllert(true);
  };

  const handleDeleteAgenda = async (data: any) => {
    console.log({ data });
    console.log(context?.selectedDoctor);

    try {
      const payload = {
        crud: "d",
        idMedint: context?.selectedDoctor.pkey,
        idPgmedt: data.idPgMedt,
        idMedpgm: data.idMedpgm,
      };

      const response = await medpgm(payload);

      if (response.data.esito === "OK") {
        setMessage("Agenda eliminata con successo");
        setSeverity("success");
      } else {
        setMessage("Errore sulla cancellazione dell'agenda");
        setSeverity("error");
      }
    } catch (error) {
      console.error("Errore sulla send di cancellazione agenda", error);
    } finally {
      props.allertMessageProps.setFn(null);
      setTimeout(() => {
        setShowAllert(false);
        handleCloseModal();
      }, 5000);
    }
  };

  //Funzioni che aprono e chiudono MedPrest selezionando una specifica modalità
  const openMedPrest = (mode: "create" | "edit" | "copy", row?: any) => {
    setMedPrest({ open: true, mode, row });
    props.setHideDetailsActions?.(true);
  };

  const closeMedPrest = () => {
    setMedPrest({ open: false });
    props.setHideDetailsActions?.(false);
  };

  //UseEffect che tiene traccia dell'apertura di MedPrest attraverso il tasto di inserimento
  //e nasconde i tab Dettaglio/Prenotazioni da MedintDetails finché rimane aperto
  useEffect(() => {
    props.setHideDetailsActions?.(medPrest.open);
    return () => props.setHideDetailsActions?.(false);
  }, [medPrest.open]);

  if (medPrest.open) {
    return (
      <Paper className="doctorInfo" sx={{ padding: 3, mt: 2 }}>
        <MedPrest
          open
          mode={medPrest.mode}
          row={medPrest.row}
          onClose={closeMedPrest}
          onConfirm={() => {
            closeMedPrest();
            props.fetchDataMedico();
          }}
        />
      </Paper>
    );
  }

  const agendaCols: GridColDef[] = [
    { field: "id" },
    {
      field: "dataIni",
      headerName: "Data Inizio",
      flex: 1,
      renderCell: (value: any) => {
        return `${dayjs(value.row.dataIni).format(`DD/MM/YYYY`)}`;
      },
    },
    {
      field: "dataFin",
      headerName: "Data Fine",
      flex: 1,
      renderCell: (value: any) => {
        return `${dayjs(value.row.dataFin).format(`DD/MM/YYYY`)}`;
      },
    },
    {
      field: "codAgenda",
      headerName: "Codice Agenda",
      flex: 1,
    },
    {
      field: "programmaAbb",
      headerName: "Programma Abbinato",
      flex: 1,
    },
    {
      field: "azioni",
      headerAlign: "center",
      align: "center",
      headerName: "Azioni",
      flex: 0.5,
      renderCell: (params: any) => {
        const row = params.row;
        const idPgMedt = String(row.idPgMedt ?? "");

        return (
          <>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                if (!idPgMedt) return;
                handleEditAgenda(params.row);
              }}
              sx={{ color: "#024E88" }}
            >
              <ModifyIcon />
            </IconButton>

            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                if (!idPgMedt) return;
                handleDuplicateAgenda(params.row);
              }}
              sx={{ color: "#024E88" }}
            >
              <CopyFromDoctorIcon />
            </IconButton>

            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onClickCancellazioneAgenda(params.row);
              }}
              sx={{ color: "#D32F2F" }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <>
      <AllertMessage
        showAllert={showAllert}
        setShowAllert={setShowAllert}
        severity={severity}
        message={message}
        dataToSend={dataToSend}
        submitFunction={props.allertMessageProps.submitFunction}
      />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 1300,
          }}
        >
          <CircularProgress size="6rem" />
        </Box>
      )}
      <Paper className="doctorInfo" sx={{ padding: 3, mt: 2 }}>
        <MedintModal
          open={isModalOpen}
          onClose={handleCloseModal}
          methods={props.methods}
          onSubmit={handleSubmitModal}
          fetchDataMedico={props.fetchDataMedico}
          type={modalType}
        />

        <Grid container justifyContent="space-between" alignItems="center">
          {selectedTab === 0 && (
            <Grid item xs={12} md={12}>
              <RHFTextField
                fullWidth
                placeholder="Note eventuali"
                name="medIntDettaglio.noteMedico"
                control={props.methods.control}
                multiline
                rows={6}
                required
                inputProps={{ maxLength: 400 }}
                helperText={
                  (props.methods.watch("medIntDettaglio.noteMedico")?.length ??
                    0) + "/400"
                }
              />
              <RHFAutocomplete
                control={props.methods.control}
                sx={{ mt: 1 }}
                name="medIntDettaglio.raggruppamentoStampaMedico"
                label="Raggruppamento per Stampa"
                options={context?.stampaRaggrPARAGGR ?? []}
                keyField="codice"
                getOptionLabel={(d: any) =>
                  `${d.codice ?? "N/a codice"} - ${
                    d.descrizione ?? "N/A"
                  }`.trim()
                }
                mapIn={(code, opts) =>
                  opts.find(
                    (o: any) => String(o.codice).trim() === String(code).trim(),
                  ) ?? null
                }
                mapOut={(opt: any) => String(opt?.codice ?? "")}
              />
            </Grid>
          )}

          {/* Tabs */}
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mt: 1 }}>
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Prestazioni Erogabili"
            />
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Agende"
            />
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Non Disponibile"
            />
          </Tabs>
        </Grid>

        {/* Pulsanti di azione */}
        {selectedTab === 0 && (
          <Grid
            container
            spacing={2}
            justifyContent="end"
            alignItems="center"
            mb={2}
          >
            <Grid item>
              <Grid container spacing={1} paddingTop={2}>
                <Grid item>
                  <Button
                    variant="outlinedError"
                    sx={{ maxHeight: "35px", gap: 0.5 }}
                  >
                    <DeleteIcon className="medintIconsOutlinedCancel" />{" "}
                    <Typography sx={{ fontWeight: "bold" }}>
                      Cancella tutto
                    </Typography>
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    sx={{ maxHeight: "35px", gap: 0.5 }}
                    onClick={() => openModal("copiaDaMedico")}
                  >
                    <CopyFromDoctorIcon className="medintIcons" />{" "}
                    <Typography sx={{ fontWeight: "bold" }}>
                      Copia da Medico
                    </Typography>
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="outlined"
                    sx={{ maxHeight: "35px", gap: 0.5 }}
                    onClick={() => openModal("inserimentoMultiplo")}
                  >
                    <MultipleAddIcon className="medintIcons" />{" "}
                    <Typography sx={{ fontWeight: "bold" }}>
                      Inserimento Multiplo
                    </Typography>
                  </Button>
                </Grid>

                <Grid item>
                  <Button
                    variant="outlined"
                    sx={{ maxHeight: "35px", mr: 1, gap: 0.5 }}
                    // onClick={() => openModal("inserimento")}
                    onClick={() => {
                      openMedPrest("create");
                      props.setHideDetailsActions?.(true);
                    }}
                  >
                    <AddIcon className="medintIcons" />{" "}
                    <Typography sx={{ fontWeight: "bold" }}>
                      Inserimento
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {/* Sezione Tabella e Bottoni laterali */}
        <Grid container spacing={2} alignItems="stretch">
          {/* Tabella */}
          <Grid item xs sx={{ maxWidth: "100%" }}>
            {selectedTab === 0 && (
              <MedintTable
                onEditClick={(row) => {
                  openMedPrest("edit", row);
                }}
                onCopyClick={(row) => openMedPrest("copy", row)}
                headers={headers}
                fetchDataMedico={props.fetchDataMedico}
                data={
                  context?.prestazioniErogabili
                    ? context.prestazioniErogabili.length < 1
                      ? [
                          {
                            Specialità: "—",
                            Codice: "—",
                            Descrizione: "—",
                            Agenda: "—",
                            Durata: "—",
                            Azioni: "—",
                          },
                        ]
                      : context.prestazioniErogabili
                    : [
                        {
                          Specialità: "—",
                          Codice: "—",
                          Descrizione: "—",
                          Agenda: "—",
                          Durata: "—",
                          Azioni: "—",
                        },
                      ]
                }
                showActionButton={true}
                actionButtonLabel="Modifica"
                onActionClick={() => console.log("Modifica")}
              />
            )}
            {selectedTab === 1 && (
              <Box mt={2}>
                <Grid container mt={2}>
                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    justifyContent={"flex-end"}
                    mb={1}
                  >
                    <Stack
                      direction={"row"}
                      gap={1}
                      display={"flex"}
                      justifyContent={"center"}
                      justifyItems={"center"}
                    >
                      <RHFCheckbox
                        label={"Agende Attive"}
                        control={props.methods.control}
                        name={"agendeAttive"}
                      />
                      <Button
                        variant="outlined"
                        sx={{
                          maxHeight: "35px",
                          maxWidth: "110px",
                          mt: 0.5,
                        }}
                        onClick={handleInsertAgenda}
                      >
                        <Stack gap={1} direction={"row"}>
                          <AddIcon className="medintIcons" />
                          <Typography sx={{ fontWeight: "bold" }}>
                            Inserisci
                          </Typography>
                        </Stack>
                      </Button>
                    </Stack>
                  </Grid>

                  <Grid item xs={12}>
                    <StyledDataGrid
                      rows={
                        props.methods.watch("agendeAttive")
                          ? dataGeneral.filter((agenda) => {
                              const dataFin = dayjs(
                                agenda.dataFin,
                                "YYYY-MM-DD",
                              );
                              return (
                                dataFin.isAfter(dayjs()) ||
                                dataFin.isSame(dayjs(), "day")
                              );
                            })
                          : (dataGeneral ?? [])
                      }
                      columns={agendaCols}
                      getRowId={(r) => r.idPgMedt ?? r.id}
                      onRowClick={(event: any) => {
                        console.log(event.row);

                        if (event?.row?.id === selectedAgenda?.id) {
                          setSelectedAgenda(undefined);
                        } else {
                          setSelectedAgenda(event?.row);
                        }
                      }}
                      sortingOrder={["desc", "asc", null]}
                      columnVisibilityModel={{
                        id: false,
                      }}
                      sx={{
                        height: 200,
                        '& .MuiDataGrid-columnHeaders [data-field="__orderBySelected__"] .MuiDataGrid-sortIcon':
                          {
                            display: "none",
                          },
                        "& .MuiDataGrid-row:hover": {
                          backgroundColor: "#f5f5f5",
                          cursor: "pointer",
                        },
                        "& .MuiDataGrid-row.Mui-selected": {
                          backgroundColor: selectedAgenda
                            ? "#e3f2fd !important"
                            : "",
                        },
                        "& .MuiDataGrid-row.Mui-selected:hover": {
                          backgroundColor: "#bbdefb !important",
                        },
                        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within":
                          {
                            outline: "none",
                          },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
            {selectedTab === 2 && (
              <>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    justifyContent={"flex-end"}
                  >
                    <Button
                      variant="outlined"
                      sx={{
                        maxHeight: "35px",
                        maxWidth: "110px",
                        mt: 0.5,
                      }}
                      onClick={() => openModal("nonDisponibile")}
                    >
                      <Stack gap={1} direction={"row"}>
                        <AddIcon className="medintIcons" />
                        <Typography sx={{ fontWeight: "bold" }}>
                          Inserisci
                        </Typography>
                      </Stack>
                    </Button>
                  </Grid>
                </Grid>
                <NotAvailableTab
                  onCopyClick={(row) => {
                    openModal("duplicaIndisponibilità");
                    props.methods.setValue("medIntIndisponibilita", {
                      idPanodi: row?.idPanodi ?? "",
                      dataInizio:
                        dayjs(row?.["Data Indisponibilità"], "DD/MM/YYYY") ??
                        "",
                      dataFine: null,
                      oraInizio: row?.["Ora Inizio"] ?? "",
                      oraFine: row?.["Ora Fine"] ?? "",
                      note: row?.Descrizione ?? "",
                    });
                  }}
                  onDeleteClick={(row) => console.log("Elimina", row)}
                  fetchDataMedico={props.fetchDataMedico}
                />
              </>
            )}
          </Grid>
        </Grid>
      </Paper>
      {selectedTab === 1 && (
        <Paper className="doctorInfo" sx={{ padding: 3, mt: 3 }}>
          <MedintBookingAgenda
            loading={loading}
            setLoading={setLoading}
            selectedAgenda={selectedAgenda}
            setSelectedAgenda={setSelectedAgenda}
            fethDataMedico={props.fetchDataMedico}
            onlyAdditionalTables
            dataGeneral={dataGeneral}
            setDataGeneral={setDataGeneral}
            dataPrestazioniErogabiliAgenda={dataPrestazioniErogabiliAgenda}
            setDataPrestazioniErogabili={setDataPrestazioniErogabili}
            dataPrestazioniAbbinate={dataPrestazioniAbbinate}
            setPrestazioniAbbinate={setPrestazioniAbbinate}
            selectedErogate={selectedErogate}
            setSelectedErogate={setSelectedErogate}
            selectedAbbinate={selectedAbbinate}
            setSelectedAbbinate={setSelectedAbbinate}
          />
        </Paper>
      )}
    </>
  );
};

export default MedintBookings;
